export class HeaderUserMenu {
  constructor() {
    this.userMenu = document.querySelector('.header-main__top__user');
    this.settingsContainer = document.querySelector('.header-main__top__user--settings');
    this.init();
  }

  init() {
    if (this.userMenu) {
      this.addClickHandler();
      this.addScrollHandler();
      this.addOutsideClickHandler();
    }
  }

  addClickHandler() {
    this.userMenu.addEventListener('click', (event) => {
      event.stopPropagation();
      this.userMenu.classList.toggle('active');
    });

    if (this.settingsContainer) {
      this.settingsContainer.addEventListener('click', (event) => {
        event.stopPropagation();
      });
    }
  }

  addScrollHandler() {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 50) {
        this.userMenu.classList.remove('active');
      }
    });
  }

  addOutsideClickHandler() {
    document.addEventListener('click', (event) => {
      if (
          !this.userMenu.contains(event.target) &&
          (!this.settingsContainer || !this.settingsContainer.contains(event.target))
      ) {
        this.userMenu.classList.remove('active');
      }
    });
  }
}